export class DumbappNamespace {
    constructor() {
        this.initialized = false;
        this.contexts = {};
        this.currentType = null;
    }
    currentContext() {
        if (!this.currentType) {
            return Object.values(this.contexts)[0];
        }
        return Object.values(this.contexts).find(it => it.type === this.currentType);
    }
    addContext(context) {
        this.contexts[context.type] = context;
    }
    removeContext(type) {
        delete this.contexts[type];
    }
    getContext(type) {
        return this.contexts[type];
    }
    account() {
        return this.currentContext().account;
    }
    chainId() {
        return this.currentContext().chainId;
    }
}
let windowLike;
export function getWindow() {
    if (windowLike) {
        return windowLike;
    }
    // @ts-ignore
    if (window) {
        // @ts-ignore
        let win = window;
        if (!win.dumbappNamespace) {
            win.dumbappNamespace = new DumbappNamespace();
        }
        windowLike = win;
    }
    else {
        windowLike = {
            dumbappNamespace: new DumbappNamespace()
        };
    }
    return windowLike;
}
